import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';

var PinOutline = function PinOutline(props) {
  var _props$color = props.color,
      color = _props$color === void 0 ? 'currentColor' : _props$color,
      size = props.size,
      style = props.style;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.99999C14.21 5.99999 16 7.78998 16 9.99998C16 12.21 14.21 14 12 14C9.78998 14 7.99999 12.21 7.99999 9.99998C7.99999 7.78998 9.78998 5.99999 12 5.99999ZM13.415 11.4149C13.78 11.05 14 10.555 14 9.99998C14 9.44498 13.78 8.95 13.415 8.585C13.05 8.22 12.555 7.99998 12 7.99998C11.445 7.99998 10.9499 8.22 10.5849 8.585C10.2199 8.95 9.99998 9.44498 9.99998 9.99998C9.99998 10.555 10.2199 11.05 10.5849 11.4149C10.9499 11.7799 11.445 12 12 12C12.555 12 13.05 11.7799 13.415 11.4149Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.675 4.47498C19.115 5.99998 20 8.09502 20 10.39C19.99 11.7 19.475 12.99 18.78 14.255C18.08 15.52 17.175 16.76 16.275 17.86C14.475 20.06 12.7 21.715 12.68 21.73C12.3 22.09 11.6999 22.09 11.3199 21.73C11.3049 21.72 10.3 20.785 9.04503 19.39C7.78503 17.995 6.26996 16.15 5.21997 14.255C4.52497 12.99 4.01 11.7 4 10.39C4 8.09502 4.88495 5.99998 6.32494 4.47498C7.75994 2.95498 9.77498 2 12 2C14.22 2 16.24 2.95498 17.675 4.47498ZM17.03 13.285C17.65 12.185 18.01 11.125 18 10.39C18 8.61002 17.3149 7.00499 16.2249 5.85498C15.1299 4.69998 13.645 4 12 4C10.355 4 8.87001 4.69998 7.77501 5.85498C6.68502 7.00499 5.99999 8.61002 5.99999 10.39C5.98999 11.105 6.33003 12.12 6.91003 13.185C7.49002 14.255 8.29498 15.375 9.11497 16.4C10.197 17.7452 11.3115 18.913 12.0003 19.6045C12.3848 19.218 12.9006 18.6813 13.4749 18.05C14.6749 16.72 16.115 14.95 17.03 13.285Z",
    fill: color
  }));
};

export { PinOutline };
